export const globalTheme = {
  colors: {
    grey1: "#292929",
    grey2: "#737373",
    grey3: "#A3A3A3",
    grey4: "#E9E9E9",
    grey5: "#EAEAEA",
    grey6: "#D6D6D6",
    grey7: "#EEEEEE",
    grey8: "#F9FAFB",
    grey9: "#FFFDFD",
    grey10: "#CECDCD",
    gradient: 'linear-gradient(90deg, #39B6D8 6.41%, #F7D344 51.47%, #E38330 96.52%)',

    white: "#fafafa",
    white1: "#ffffff",
    white2: "#FBFBFB",

    black: '#0A0A0B',
    black2: '#111111',
    black3: '#292929',
    black4: '#101010',
    black5: '#0B0921',
    black6: '#383838',

    primary: '#FF7143',
    primaryDark: '#FF563D',
    primary1: '#FFEEEC',
    primary2: '#F4D7D2',
    primary3: '#FFBAB0',
    secondary: '#737373',

    green: "#D5FFE9",
    green0: "#F7FFFA",
    green1: "#EAFFF4",
    green2: "#00875A",
    green3: "#D1FADF",
    green5: "#13B762",
    green6: "#36CE00",
    green7: "#D9FDD3",

    yellow: "#FFC82D",
    yellow2: "#FFF9E4",

    error: "#e53935",
    error1: "#f6bdbc",
    error2: "#ee7b78",
    error3: "#c11d19",

    red: "#F04438",

    nuetral1: "#f7f7f7",
    nuetral2: "#f0f0f0",
    nuetral3: "#cccccc",
    nuetral4: "#aaaaaa",
    nuetral5: "#9f9c9c",
    nuetral6: "#888888",
    nuetral7: "#726c6c",
    nuetral8: "#666666",
    nuetral9: "#433e3f",
    nuetral10: "#2b2829",
    nuetral11: "#151314",
    nuetral12: "#40474F",
    nuetral13: "#5a5a5a",
    nuetral14: '#36363E',
    nuetral15: '#1A1A1A',
    nuetral16: '#e7e7e7',

    warning: "#f7b602",
    warning1: "#feedbe",
    warning2: "#fedc7e",
    warning3: "#fbc532",
    warning4: "#d3a012",

    blue: "#D9F1FD",
    blue1: "#F3F9FD",
    blue2: "#0F5FEB",
    blue3: "#4589FF",
    blue4: "#1D6EF9",
    blue5: "#3350E9",
    blue6:"#313957",

    purple1: "#A402E8",

    // Add more colors as needed
    success4: "#357b38",
    success5: "#DBF6ED",
    success6: "#21b585",

    error4: "#881412",

  },

  shadow: [`0px 0px 40px rgba(0, 0, 0, 0.16)`],
  fonts: {
    interThin: "interThin",
    interExtraLight: "interExtraLight",
    interLight: "interLight",
    interRegular: "interRegular",
    interSemiBold: "interSemiBold",
    interBold: "interBold",
    interHeavy: "interHeavy",
    inter: "inter",
  },

  fontWeights: {
    normal: "400",
    medium: "500",
    semibold: "600",
    bold: "700",
    extrabold: "800",
  },
};